import { debugLog, type PlacementId } from '@schibsted-nmp/advertising-shared';

/** Fired when a creative iframe fires its onload event. */
export function onSlotOnload(event: googletag.events.SlotOnloadEvent) {
  const placementId = event.slot.getSlotElementId() as PlacementId;
  debugLog(`PlacementId: ${placementId}: slotOnLoad event:`, event);
}
